import { object, string } from "superstruct";

const ShareGiftRegistryResponseSchema = object({
    shareGiftRegistryUrl: string(),
});

export default ShareGiftRegistryResponseSchema;
